import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { TagFilter } from './TagFilter';

const TagFilterBridge = react2angular(TagFilter, [
  'usedTagIds',
  'initialSelectedTagIds',
  'tagLabel',
  'popoverAlign',
  'onApply'
]);
export default TagFilterBridge;
